import clsx from 'clsx';
import useCrosswalkStyles from './styles';
import { NewCrosswalkForm } from './NewCrosswalkForm';
import { CrosswalkList } from './CrosswalkList';
import { useDynamicDocumentationLink } from 'components/layouts/PageHeader/useDynamicDocumentationLink';

export const Crosswalks: React.FunctionComponent = () => {
  const classes = useCrosswalkStyles();

  useDynamicDocumentationLink({ link: 'LOCATIONS_ADD_CROSSWALKS' });

  return (
    <>
      <NewCrosswalkForm />
      <div className={clsx(classes.crosswalkContainer)}>
        <CrosswalkList />
      </div>
    </>
  );
};
